import Head from 'next/head'
import Image from 'next/image'
import { useState } from 'react'
import { useViewport } from 'contexts/viewport'
import { TeamGamesMetaDescription, TeamGamesOGImagePath, wpRoutePrefix } from 'utils/constants'

import AppHeader from 'components/app_header'
import AppFooter from 'components/app_footer'
import MetaTags from './shared/meta_tags'
import Masthead from './shared/masthead'
import FeaturedFAQSection from './shared/featured_faqs'
import ModalMessage from 'components/modals/modal_message'
import ModalJoinOuting from 'components/modals/modal_join_outing'

import styles from 'styles/help_details.module.scss'

export const FeaturedCardsPage = () => {
  const goToListingPage = (tag: string) => {
    location.href = `${wpRoutePrefix}/${tag}`
  }

  const goToFaqPage = (slug: string, id = '') => {
    location.href = wpRoutePrefix + (id ? '/faq/' + slug + '#' + id : '/faq/' + slug)
  }

  const goToZoomMarketplace = () => {
    window.open('https://marketplace.zoom.us/apps/lVVV3EvrQoibUofep5JT-w', '_blank')
  }

  const featuredCards = [
    {
      key: 'announcements',
      onClick: () => goToListingPage('announcement'),
      imageSrc: '/images/help_details/announcement.png',
      imageAlt: 'Announcements',
      title: 'Announcements',
      description: 'Find out what we have coming up, and all news related to Team Games!',
    },
    {
      key: 'inviting-teams',
      onClick: () => goToFaqPage('how-to-create-a-team-outing', 'invite-your-team'),
      imageSrc: '/images/help_details/inviting_teams.png',
      imageAlt: 'Inviting Teams',
      title: 'Inviting Teams',
      description: 'Learn how to share your Outing details with your team',
    },
    {
      key: 'release-notes',
      onClick: () => goToListingPage('release-notes'),
      imageSrc: '/images/help_details/release_notes.png',
      imageAlt: 'Release Notes',
      title: 'Release Notes',
      description: 'What’s new and what’s changed with each update',
    },
    {
      key: 'our-games',
      onClick: () => goToListingPage('all-games'),
      imageSrc: '/images/help_details/our_games.png',
      imageAlt: 'Our Games',
      title: 'Our Games',
      description: 'Find detailed FAQs on every game currently offered by Team Games for your Outings',
    },
    {
      key: 'scheduling',
      onClick: () => goToFaqPage('how-to-create-a-team-outing', 'schedule-the-outing'),
      imageSrc: '/images/help_details/scheduling.png',
      imageAlt: 'Scheduling',
      title: 'Scheduling',
      description: 'Everything you need to know when scheduling your next team Outing',
    },
    {
      key: 'teamgames',
      onClick: goToZoomMarketplace,
      imageSrc: '/images/help_details/teamgames.png',
      imageAlt: 'Team Games on Zoom',
      title: 'Team Games on Zoom',
      description: 'Add the Team Games app to Zoom to enjoy the Team Games experince in your meetings',
    },
    {
      key: 'general-faq',
      onClick: () => goToListingPage('faq'),
      imageSrc: '/images/help_details/faq.png',
      imageAlt: 'General FAQ',
      title: 'General FAQ',
      description: 'FAQs on how to use Team Games for beginners to pros',
    },
  ]

  return (
    <div className={styles.container} id="help_details_page">
      <MetaTags />

      <AppHeader transparent />

      <Masthead query="" />

      <div className={styles.card_grid_section}>
        <div className={styles.card_grid_wrapper}>
          {featuredCards.map(card => (
            <div key={card.key} className={styles.card_grid_item}>
              <div className={styles.card} onClick={card.onClick}>
                <div className={styles.card_bg}>
                  <div>
                    <Image src={card.imageSrc} alt={card.imageAlt} layout="fill" objectFit="contain" />
                  </div>
                </div>
                <div className={styles.card_info}>
                  <div className={'heading_2 ' + styles.card_title}>{card.title}</div>
                  <div className={'description_small ' + styles.card_desc}>{card.description}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <FeaturedFAQSection />

      <ModalMessage />

      <ModalJoinOuting />

      <AppFooter />
    </div>
  )
}

export default FeaturedCardsPage
